export enum SubscriptionTariff {
  Start = 1,
  Pro = 2,
  Max = 3,
}

export const getTariffName = (tariff: SubscriptionTariff): string => {
  switch(tariff) {
  case SubscriptionTariff.Start:
    return 'Старт'
  case SubscriptionTariff.Pro:
    return 'Про'
  case SubscriptionTariff.Max:
    return 'Макс'
  default:
    console.warn('Передан несуществующий тариф: ' + tariff)
    return ''
  }
}

export const hasFolderManagement = (tariff: SubscriptionTariff): boolean => {
  switch(tariff) {
  case SubscriptionTariff.Start:
    return false
  case SubscriptionTariff.Pro:
    return true
  case SubscriptionTariff.Max:
    return true
  default:
    console.warn('Передан несуществующий тариф: ' + tariff)
    return false
  }
}

export const hasGenerationsStorage = (tariff: SubscriptionTariff): boolean => {
  switch(tariff) {
  case SubscriptionTariff.Start:
    return false
  case SubscriptionTariff.Pro:
    return true
  case SubscriptionTariff.Max:
    return true
  default:
    console.warn('Передан несуществующий тариф: ' + tariff)
    return false
  }
}

export const canBeObtainedByFree = (tariff: SubscriptionTariff): boolean => {
  switch(tariff) {
  case SubscriptionTariff.Start:
    return true
  case SubscriptionTariff.Pro:
    return false
  case SubscriptionTariff.Max:
    return false
  default:
    console.warn('Передан несуществующий тариф: ' + tariff)
    return false
  }
}

export const getGenerationsCount = (tariff: SubscriptionTariff): number | undefined => {
  switch(tariff) {
  case SubscriptionTariff.Start:
    return 25
  case SubscriptionTariff.Pro:
    return 100
  case SubscriptionTariff.Max:
    return undefined
  default:
    console.warn('Передан несуществующий тариф: ' + tariff)
    return 5
  }
}

export enum SubscriptionDuration {
  Month = 1,
  SixMonth = 2,
  Year = 3,
}

export const getCountMonths = (duration: SubscriptionDuration): number => {
  switch(duration) {
  case SubscriptionDuration.Month:
    return 1
  case SubscriptionDuration.SixMonth:
    return 6
  case SubscriptionDuration.Year:
    return 12
  default:
    console.warn('Передана несуществующая длительность тарифа: ' + duration)
    return 0
  }
}

const costs: { [tariff: number]: { [duration: number]: number } } = {
  [SubscriptionTariff.Start]: {
    [SubscriptionDuration.Month]: 490,
    [SubscriptionDuration.Year]: 4320,
  },
  [SubscriptionTariff.Pro]: {
    [SubscriptionDuration.Month]: 990,
    [SubscriptionDuration.Year]: 8880,
  },
  [SubscriptionTariff.Max]: {
    [SubscriptionDuration.Month]: 1990,
    [SubscriptionDuration.Year]: 17880,
  },
}

export const getActualCost = (tariff: SubscriptionTariff, duration: SubscriptionDuration): number => {
  return costs[tariff][duration] ?? 0
}
